import { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [profile, setProfile] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cms_profile')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cms_token');
    if (token) {
      api.get('/auth/me').then(({ data }) => {
        setProfile(data);
        localStorage.setItem('cms_profile', JSON.stringify(data));
      }).catch(() => {}).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  async function login(phone, password) {
    const { data } = await api.post('/auth/login', { phone, password });
    localStorage.setItem('cms_token', data.token);
    localStorage.setItem('cms_profile', JSON.stringify(data));
    setProfile(data);
    return data;
  }

  async function register(payload) {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem('cms_token', data.token);
    localStorage.setItem('cms_profile', JSON.stringify(data));
    setProfile(data);
    return data;
  }

  function logout() {
    localStorage.removeItem('cms_token');
    localStorage.removeItem('cms_profile');
    setProfile(null);
  }

  return (
    <AuthContext.Provider value={{ profile, setProfile, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
